import Vue from 'vue';
import PaginationList from './paginated-list-container.vue';
import PaginationListHeading from './paginated-list-container--list-heading.vue';
import PaginationCallbacks from './pagination-callbacks.js';
import { buildGet } from '../../utils/ajax';

window.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector('[data-pagination-mount]');

  const callback = new PaginationCallbacks({ el: document.querySelector('[data-pagination-insertion]') });
  const paginationBefore = callback.before.bind(callback);
  const paginationAfter = callback.after.bind(callback);

  if (el) {
    new Vue({
      el: '[data-pagination-mount]',
      data: {
        dynamicComponent: el.getAttribute('data-pagination-mount') === 'listHeading' ? PaginationListHeading : PaginationList,
        currentPage: parseInt(el.getAttribute('data-current-page')),
        lastPage: parseInt(el.getAttribute('data-last-page')),
        showMoreItemsButtonHTML: el.getAttribute('data-show-more-items-button-html'),
        noMoreItemsMessage: el.getAttribute('data-no-more-items-message'),
        get: buildGet(el.getAttribute('data-fetch-base-url')),
        getSetupFunc: paginationBefore,
        getCompletionFunc: paginationAfter
      },
      template:
        `
        <component
          :is=dynamicComponent
          :initialCurrentPage=currentPage
          :initialLastPage=lastPage
          :showMoreItemsButtonHTML=showMoreItemsButtonHTML
          :noMoreItemsMessage=noMoreItemsMessage
          :fetchPaginatedListFunc=get
          :fetchPaginatedListSetupFunc=getSetupFunc
          :fetchPaginatedListCompletedFunc=getCompletionFunc
        />
      `
    });
  }
});
